var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.waterSiteVisible
    ? _c("div", [
        _c("h4", [_vm._v("Site " + _vm._s(_vm.index + 1))]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: {
              "form-group--error":
                _vm.$v.value.spid.$error ||
                _vm.value.quoteToolUsable == false ||
                _vm.validSpid == false,
            },
          },
          [
            _c("label", { attrs: { for: "spid" + _vm.index } }, [
              _vm._v(_vm._s(_vm.labels.stepTwoFindSiteSPIDLabel) + "*"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-sm-8" }, [
                _c("input", {
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    maxlength: "13",
                    id: "spid" + _vm.index,
                    placeholder: "This can be found on your bill",
                  },
                  domProps: { value: _vm.value.spidLookup },
                  on: {
                    input: function ($event) {
                      return _vm.updateValue("spidLookup", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.$v.value.spid.required
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Valid spid number is required."),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "u-mt-0 u-mb-0 u-ptb-10 btn--full-width",
                    attrs: { disabled: _vm.isSpidButtonDisabled },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.findSPID(_vm.index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.labels.stepTwoFindSiteButtonText))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.fetchingSPID ? _c("p", [_vm._v("Loading...")]) : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.value.spid && !_vm.fetchingSPID
                ? _c("div", [
                    _vm.value.quoteToolUsable == false
                      ? _c("div", { staticClass: "error" }, [
                          _vm._v(
                            "\n                    Because this site has multiple water meters, we won't be able to provide you with an instant quote online. If you choose to continue, we'll be in touch to provide a quote using the information provided.\n                "
                          ),
                        ])
                      : _c("div", [
                          _c("address", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.value.address.street)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.value.address.town)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.value.address.country) +
                                "\n                        " +
                                _vm._s(_vm.value.address.postcode) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                        Estimated usage at this site - "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.value.usage) + " m"),
                              _c("sup", [_vm._v("3")]),
                              _vm._v(" " + _vm._s(_vm.value.frequency)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: {
                                "form-group--error": _vm.$v.value.usage.$error,
                              },
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-xs-12" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "usage" + _vm.index } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.labels.stepTwoYourWaterUsageLabel
                                        ) + "*"
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-8 custom-number-field",
                                  },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "form-control custom-number-field--mCubed",
                                      attrs: {
                                        type: "text",
                                        maxlength: "7",
                                        id: "usage" + _vm.index,
                                      },
                                      domProps: { value: _vm.value.usage },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          if (
                                            $event.target !==
                                            $event.currentTarget
                                          )
                                            return null
                                        },
                                        input: function ($event) {
                                          return _vm.updateValue(
                                            "usage",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.value.frequency.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-xs-12 col-sm-4" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "custom-select" },
                                          [
                                            _c(
                                              "select",
                                              {
                                                staticClass: "form-control",
                                                domProps: {
                                                  value: _vm.value.frequency,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.updateValue(
                                                      "frequency",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "annually",
                                                    },
                                                  },
                                                  [_vm._v("Annually")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "half-yearly",
                                                    },
                                                  },
                                                  [_vm._v("Half-yearly")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "quarterly",
                                                    },
                                                  },
                                                  [_vm._v("Quarterly")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: { value: "monthly" },
                                                  },
                                                  [_vm._v("Monthly")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.$v.value.usage.required ||
                          !_vm.$v.value.usage.numeric ||
                          !_vm.$v.value.usage.isPositive
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(
                                  "\n                        Valid water usage amount is required.\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.value.frequency.required
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(
                                  "\n                        Frequency is required.\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasReferenceNumber
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.value.customerReferenceNumber
                                          .$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "referenceNum" + _vm.index,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.labels
                                              .stepTwoCustomerReferenceNumberLabel
                                          ) + "*"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        id: "referenceNum" + _vm.index,
                                        placeholder:
                                          _vm.labels
                                            .stepTwoCustomerReferenceNumberPlaceholder,
                                      },
                                      domProps: {
                                        value:
                                          _vm.value.customerReferenceNumber,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          if (
                                            $event.target !==
                                            $event.currentTarget
                                          )
                                            return null
                                        },
                                        input: function ($event) {
                                          return _vm.updateValue(
                                            "customerReferenceNumber",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$v.value.customerReferenceNumber
                                  .required ||
                                !_vm.$v.value.customerReferenceNumber.numeric ||
                                !_vm.$v.value.customerReferenceNumber
                                  .minLength ||
                                !_vm.$v.value.customerReferenceNumber.maxLength
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.labels
                                              .stepTwoCustomerReferenceNumberValidationMsg
                                          ) +
                                          "\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isBillingSite,
                                    expression: "isBillingSite",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.isBillingSite)
                                    ? _vm._i(_vm.isBillingSite, null) > -1
                                    : _vm.isBillingSite,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isBillingSite,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isBillingSite = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isBillingSite = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isBillingSite = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.labels
                                      .stepTwoUseSiteBillingCheckboxLabel
                                  ) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "checkmark" }),
                            ]),
                          ]),
                        ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }